export default "<span>{{ countdown }}</span>"